import { useMemo } from 'react';
import { useTranslations, TK_PREFIX } from 'js/hooks/i18n';

export const useTranslationPublicAPI = () => {
    const translate = useTranslations(TK_PREFIX);

    return useMemo(() => ({
        /**
         * Retrieves a value of a translation key if it was currently loaded on a page.
         * Value corresponds to currently selected locale.
         * @memberOf Playtech.API.translation
         * @function
         * @param {string} Key, without `playtech.mobile.` prefix.
         * @param {string[]} [replacements=[]] Array of replacements that will substitute {i} in the string, where i -- index in the array.
         * @param {string} [defaultValue=''] Default value in case translation does not exists.
         * @example
         * // 'playtech.mobile.system.my.tk'
         * Playtech.API.translation.translate('system.my.tk');
         * @example
         * // 'bar'
         * Playtech.API.translation.translate('system.my.foo');
         * @example
         * // 'bar'
         * Playtech.API.translation.translate('playtech.mobile.system.my.foo');
         * @example
         * // 'foo with bar inside value'
         * Playtech.API.translation.translate('playtech.mobile.foo', ['bar']);
         * @example
         * // 'playtech.mobile.system.my.tk' value contains {0} {1}
         * Playtech.API.translation.translate('my.tk', [replaceStr1, replaceStr2]);
         * @example
         * // 'default value'
         * Playtech.API.translation.translate('my.non-exist.tk', [replaceStr1, replaceStr2], 'default value');
         */
        translate
    }), [translate]);
};
